import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    padding: '20px 15px',
  },
  title: {
    fontSize: 48,
    color: theme.palette.primary.main,
    fontFamily: 'DM Sans , sans-serif',
    fontSize: '40px',
    fontWeight: 'bold',
    alignSelf: 'flex-start',
  },
  description: {
    color: '#777777',
    textAlign: 'left',
  },
  sectionWrapper: {
    marginBottom: '15px',
  },
  label: {
    color: theme.palette.secondary.main,
  },
  requiredLabel: {
    color: 'red',
  },
}));

const NOANSWER = 'No Response';

const SummarySection = ({ titles, values, optionalQuestions }) => {
  const classes = useStyles();

  return (
    <>
      {Object.keys(titles).map((item) => {
        if (item == 'major') {
          return (
            <div className={classes.sectionWrapper} key={item}>
              <Typography variant="h3" className={classes.label}>
                {titles[item]}
              </Typography>
              <p
                className={
                  values[item].length !== 0 ? null : classes.requiredLabel
                }>
                {values[item].length !== 0
                  ? values[item].join(' , ')
                  : NOANSWER}
              </p>
            </div>
          );
        } else if (item == 'attendedHWBefore' && values[item] !== null) {
          const attended = values[item] ? 'Yes' : 'No';
          return (
            <div className={classes.sectionWrapper} key={item}>
              <Typography variant="h3" className={classes.label}>
                {titles[item]}
              </Typography>
              <p>{attended}</p>
            </div>
          );
        } else if (item == 'swag' && values[item] !== null) {
          const swag = values[item] ? 'Yes' : 'No';
          return (
            <div key="swag-tshirt">
              <div className={classes.sectionWrapper} key={item}>
                <Typography variant="h3" className={classes.label}>
                  {titles[item]}
                </Typography>
                <p>{swag}</p>
              </div>
              {values[item] && (
                <div className={classes.sectionWrapper} key={'shirtSize'}>
                  <Typography variant="h3" className={classes.label}>
                    What is your t-shirt size?
                  </Typography>
                  <p>{values['shirtSize']}</p>
                </div>
              )}
            </div>
          );
        } else {
          const isRequired = optionalQuestions.indexOf(item) < 0;
          return (
            <div className={classes.sectionWrapper} key={item}>
              <Typography variant="h3" className={classes.label}>
                {titles[item]}
              </Typography>
              <p
                className={
                  values[item] && isRequired
                    ? null
                    : isRequired
                    ? classes.requiredLabel
                    : null
                }>
                {values[item] ? values[item] : NOANSWER}
              </p>
            </div>
          );
        }
      })}
    </>
  );
};

const Summary = ({ state, canMoveOn }) => {
  const classes = useStyles();
  const { aboutYouInfo, yourStoryInfo, optionalInfo } = state;

  const aboutYouTitleList = {
    pronouns: 'Preferred Pronous',
    birthday: 'Date of Birth',
    school: 'School',
    schoolYear: 'Year of Study',
    major: 'Your Major',
    resume: 'Resume',
    linkedin: 'LinkedIn',
    github: 'Github',
    otherLink: 'Other Links',
    address: 'Address',
    addressTwo: 'Address 2',
    province: 'Province',
    city: 'City',
    postalCode: 'Postal/Zip Code',
    swag: 'Do you want to receive swag from Hack Western?',
    attendedHWBefore: 'Have you attended Hack Western before?',
    hackathonsAttendedBefore: 'How many Hack Western have you attended?',
  };

  const yourStoryTitleList = {
    q1coolProject:
      'Tell us about a cool project that you worked on or want to work on (it doesn’t have to be technical!) ',
    q2takeAwayHW: 'What do you hope to take away from Hack Western?',
    qbonus: 'What would you do if quarantine lasted for another year and why?',
  };

  const optionalQuestionTitleList = {
    raceEthnicity: 'What is your race/ethnicity?',
    gender: 'What is your gender?',
    sexualOrientation: 'What is your sexual orientation?',
  };

  const optionalQuestions = [
    'linkedin',
    'github',
    'otherLink',
    'addressTwo',
    'swag',
    'raceEthnicity',
    'gender',
    'sexualOrientation',
  ];

  if (aboutYouInfo.swag === true) {
    optionalQuestions.push('shirtSize');
  }

  return (
    canMoveOn && (
      <div className={classes.root}>
        <p className={classes.title}>Summary</p>
        <p className={classes.description}>
          Please review and make any changes to your application before
          submitting.
        </p>

        <SummarySection
          titles={aboutYouTitleList}
          values={aboutYouInfo}
          optionalQuestions={optionalQuestions}
        />
        <SummarySection
          titles={yourStoryTitleList}
          values={yourStoryInfo}
          optionalQuestions={optionalQuestions}
        />
        <SummarySection
          titles={optionalQuestionTitleList}
          values={optionalInfo}
          optionalQuestions={optionalQuestions}
        />
      </div>
    )
  );
};

export default Summary;
